import React from "react";
const inputStyle = {
    width: "90%",
    // fontFamily: "Roboto-Regular",
    fontWeight: 400,
    fontSize: 12,
    textAlign: "left",
    WebkitTextFillColor: "#3c424e",
    color: "#3c424e",
    border: "none",
    padding: "10px"
};
export default class InputElement extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            eyeOpen: false
        };
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onFieldEnter = this.onFieldEnter.bind(this);
        this.toggleEye = this.toggleEye.bind(this);
    }

    onFieldChange(ev) {
        if (this.props.onChange) this.props.onChange(ev, ev.target.value);
    }

    onFieldEnter(ev) {
        if (this.props.onEnter && this.props.value.trim()) this.props.onEnter(ev);
    }

    toggleEye() {
        const { eyeOpen } = this.state;
        this.setState({
            eyeOpen: !eyeOpen
        });
    }

    getValidVal = val => {
        if (val === undefined || val === null) {
            return "";
        }

        return val;
    };

    render() {
        const {
            name,
            title,
            style,
            value,
            placeholder,
            disabled,
            wrapperStyle,
            type,
            autoComplete,
            autoFocus,
            maxLength,
            minLength
        } = this.props;
        const { eyeOpen } = this.state;
        let cursor = disabled ? { cursor: "no-drop" } : {};

        return (
            <div
                style={Object.assign(
                    {},
                    { margin: this.props.className == "inputElement" ? "0px" : "7px 0px" },
                    wrapperStyle
                )}
            >
                {title ? (
                    <div
                        style={{
                            // fontFamily: "Roboto-Regular",
                            fontWeight: 400,
                            fontSize: 12,
                            color: "#3c424e",
                            marginBottom: 7
                        }}
                    >
                        {title}
                    </div>
                ) : null}
                <div
                    style={{
                        position: "relative",
                        backgroundColor:
                            this.props.className == "inputElement" ? "#fff" : "#fdfdfd",
                        opacity:
                            (this.props.className == "withdrawWalletMoney" ||
                                this.props.className == "loadWalletMoney") &&
                            disabled
                                ? 0.3
                                : ""
                    }}
                >
                    <input
                        className={`${this.props.className || ""} searchFilterTextInput`}
                        autoComplete={autoComplete || "off"}
                        ref="genericInputElement"
                        key={name || "genericInputElement"}
                        type={type === "password" && !eyeOpen ? "password" : "text"}
                        name={name || title}
                        disabled={disabled || false}
                        placeholder={placeholder || title || ""}
                        style={Object.assign(
                            {},
                            inputStyle,
                            style,
                            this.props.onEnter ? { width: "100%", paddingRight: 28 } : {},
                            cursor,
                            {
                                border:
                                    this.props.className == "withdrawWalletMoney" ||
                                    this.props.className == "loadWalletMoney"
                                        ? "1px solid #e8edf4"
                                        : "none",
                                borderRadius:
                                    this.props.className == "withdrawWalletMoney" ||
                                    this.props.className == "loadWalletMoney"
                                        ? "3px"
                                        : "none"
                            }
                        )}
                        value={this.getValidVal(value)}
                        onChange={this.onFieldChange}
                        onKeyDown={ev => {
                            if (ev.keyCode === 13) this.onFieldEnter(ev);
                        }}
                        autoFocus={autoFocus ? autoFocus : ""}
                        maxLength={maxLength}
                        minLength={minLength}
                    />
                    {type === "password" && value && (
                        <button
                            type="button"
                            className="password-eye-button"
                            onClick={this.toggleEye}
                        >
                            <img
                                alt="password-eye"
                                src={`/assets/images/${eyeOpen ? "show" : "hide"}-password.svg`}
                            />
                        </button>
                    )}
                    {this.props.onEnter && (
                        <img
                            onClick={this.onFieldEnter}
                            style={{
                                position: "absolute",
                                top: "9px",
                                right: "10px",
                                cursor: "pointer"
                            }}
                            src={
                                this.props.className == "loadWalletMoney"
                                    ? "/assets/images/load-arrow.svg"
                                    : this.props.className == "withdrawWalletMoney"
                                    ? "/assets/images/withdraw-arrow.svg"
                                    : "/assets/images/enter-icon.svg"
                            }
                            height="14"
                            width="14"
                        />
                    )}
                </div>
            </div>
        );
    }
}
